import { useState } from 'react';
import { SelectField, TextArea, TextField } from '../../ui/kit/components/forms';
import type { SeriesStartMode } from '../../lib/series';
import '../series/series.css';

export const DELEGATE = 'Please propose this from my idea and answers for my review.';

const START_MODES: { id: SeriesStartMode; label: string; hint: string }[] = [
  { id: 'idea', label: 'Start from an idea', hint: 'Shape the series with Cue in chat.' },
  { id: 'story', label: 'Bring a complete story', hint: 'Cue reads it into a Master Story draft for your review.' },
  { id: 'episodes', label: 'Bring existing episode scripts', hint: 'Kept as source material; nothing is approved by importing.' },
];

/** Series intake. Anything left as "Cue proposes" is recorded as delegated, never as a creator decision. */
export default function MicrodramaFields({ startMode, onStartMode }: { startMode: SeriesStartMode; onStartMode: (mode: SeriesStartMode) => void }) {
  const [count, setCount] = useState('5 episodes');
  return <>
    <fieldset className="studio-project-setup-wide series-start-modes">
      <legend className="bs-small">How do you want to start?</legend>
      {START_MODES.map(mode => (
        <label key={mode.id} className="bs-small">
          <input type="radio" name="startMode" value={mode.id} checked={startMode === mode.id} onChange={() => onStartMode(mode.id)} />
          <span><strong>{mode.label}</strong> <span className="bs-muted">{mode.hint}</span></span>
        </label>
      ))}
    </fieldset>
    <SelectField label="Episodes" name="episodes" value={count} onChange={event => setCount(event.target.value)} options={[...['3', '5', '8', '12', '20'].map(n => ({ value: `${n} episodes`, label: `${n} episodes` })), { value: DELEGATE, label: 'Let Cue propose' }]} hint="You can change this before agreeing the Series Deal Memo." />
    <SelectField label="Each episode runs" name="episodeLength" defaultValue="90 seconds" options={[...['60 seconds', '90 seconds', '2 minutes', '3 minutes', '5 minutes'].map(value => ({ value, label: value })), { value: DELEGATE, label: 'Let Cue propose' }]} hint="Per-episode length. The series total is computed from the planned episodes." />
    <TextField label="Dialogue language" name="language" placeholder="For example: Hindi dialogue" />
    <TextField label="Audience" name="audience" placeholder="For example: Teen and adult audience" />
    {startMode !== 'idea' && (
      <TextArea className="studio-project-setup-wide" label={startMode === 'story' ? 'Your complete story' : 'Your episode scripts'} name="source" rows={6} placeholder={startMode === 'story' ? 'Paste the complete story. It becomes a draft for review, not an approved Master Story.' : 'Paste the episode scripts in order. Cue reads them before planning.'} required />
    )}
  </>;
}
